import { MaterialPhysics } from "src/store/api/generatedApi";

export const divideByYield = (
  value: number,
  materialPhysics: MaterialPhysics
) => {
  return value / (materialPhysics.yield_percent / 100);
};

export const calculateLiquidPriceInclElectricity = (
  specificPrice: number,
  materialPhysics: MaterialPhysics,
  electricalEnergyPrice: number
) => {
  const liquidPrice = divideByYield(specificPrice, materialPhysics);
  const electricalEnergyCostPerTonne = divideByYield(
    // (kWh/tonne) × (€/kWh) = €/tonne
    materialPhysics.electrical_energy_consumption * electricalEnergyPrice,
    materialPhysics
  );
  return liquidPrice + electricalEnergyCostPerTonne;
};
